document.addEventListener('DOMContentLoaded', () => {
    const zipCodeInput = document.getElementById("zipcode");
    // console.log("zipcode ", zipCodeInput)
    zipCodeInput.addEventListener('input', () => {

        let isNumber = !isNaN(zipCodeInput.value) && zipCodeInput.value.trim() !== '';
        // console.log(isNumber)
        if(zipCodeInput.value.length >= 5 && isNumber){
            whatConsultOptions(zipCodeInput.value)
        }else{
            const divOption1 = document.getElementById("checkOptions1");
            // const divOption2 = document.getElementById("checkOptions2");
            // const divOption3 = document.getElementById("checkOptions3");
            const resetViz = document.getElementById("reset-consult");
            const infoText = document.querySelector(".typeText")
            // divOption2.style.display = "none";
            divOption1.style.display = "none";
            // divOption3.style.visibility = "hidden";
            infoText.style.display = 'flex';
        }
    })
})

async function whatConsultOptions(zipcode) {
    const divOption1 = document.getElementById("checkOptions1");
    // const divOption2 = document.getElementById("checkOptions2");
    // const divOption3 = document.getElementById("checkOptions3");
    const resetViz = document.getElementById("reset-consult");
    const infoText = document.querySelector(".typeText")

    let radius = 50;

    let latLong = await getUserLatLon(zipcode)
    // console.log("lat long ", latLong)

    let storesNearBy = await getStores(latLong.latitude, latLong.longitude, radius)
    // console.log("Nearby Stores ", storeNearBy)

    let inRange = storesNearBy[0]?.distance.value < 50;
    // console.log('in range ', inRange)
    // radio buttons
    if (inRange) {
        // divOption2.style.display = "flex";
        divOption1.style.display = "flex";
    }
    // divOption3.style.visibility = "visible";
    // resetViz.style.display = "flex";
    infoText.style.display = 'none';



}


/**
 * 
 * 
 *      FUNCTIONS
 * 
 */
function getUserLatLon(zipcode) {
    const apiKey = "AIzaSyAZJfBF2JJUcJUiTj-CebLOz2xGpGBmEs4";
    const zipCode = zipcode;
    // console.log(zipcode);
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${apiKey}`;

    return new Promise((resolve, reject) => {
        fetch(geocodeUrl)
        .then((response) => response.json())
        .then((data) => {
            if (data.results && data.results.length > 0) {
            const location = data.results[0].geometry.location;
            const latitude = location.lat;
            const longitude = location.lng;
            resolve({ latitude, longitude });
            } else {
            reject("No results found for the provided zip code.");
            }
        })
        .catch((error) => {
            reject(`Error fetching data from the Geocoding API: ${error}`);
        });
    });
}
async function getStores(lat, lng, radius) {
    let locator_token = '16723da996a0c8'
    let base_url = `https://api.storepoint.co/public/v1/${locator_token}/locations?lat=${lat}&lng=${lng}&radius=${radius}&unit=miles&sort=distance&limit=20`
    // console.log('base url ', base_url)
    try{
        const response = await fetch(base_url);
        const data = await response.json();
        let allLocations = data.data.locations
        return allLocations
    }catch(e){
        console.error('Error getting stores ', e)
    }
}
function updateConsult(selectedValue) {
    const InHome = document.getElementById("custentity43");
    const Virtual = document.getElementById("custentity44");
    const InStore = document.getElementById("custentity45");
  if (selectedValue === "home") {
    InHome.value = "T";
    Virtual.value = "";
    InStore.value = "";
  } else if (selectedValue === "virtual") {
    Virtual.value = "T";
    InHome.value = "";
    InStore.value = "";
  } else if (selectedValue === "store") {
    InStore.value = "T";
    Virtual.value = "";
    InHome.value = "";
  } else {
    InStore.value = "";
    Virtual.value = "";
    InHome.value = "";
  }
}
